import React from 'react';
import ReactDOM from 'react-dom';
import './modal.scss';

import { Transition } from 'react-transition-group';

import Backdrop from './backdrop';


const Modal = ({show, className, animation, style, children, onCancel, error, exit}) => {
  const content = ( 
    <Transition in={show} mountOnEnter unmountOnExit timeout={700}  >
      <div className={`${!error && 'mod'}  ${error && 'err'} ${className} ${animation}`}
      style={style}
      > 
        {show && !error ? <Backdrop onClick={onCancel}/> : null}  
        {children}
      </div>
    </Transition>
  )
  return ReactDOM.createPortal(content, 
  document.getElementById('modal-hook'));
}


export default Modal;
